// regeneratorRuntime import is needed to prevent a build-time error with it not being defined.
// TODO: figure out why the error is occurring when this import isn't included
import regeneratorRuntime from 'regenerator-runtime'; // eslint-disable-line no-unused-vars

import fetch from 'isomorphic-fetch';
import { createAction } from 'redux-actions';
import getConfig from 'next/config';

import { parseOnClient } from 'lib/urlUtils';

// Returns a Thunk
export default function ({
  endpoint,
  types,
  additionalData,
  api,
  cacheKey,
  failedValidationCallback = null,
}) {
  return async (dispatch, getState) => {
    if (failedValidationCallback) {
      return failedValidationCallback(dispatch);
    }

    // getConfig is undefined until after next is instantiated
    // moving inside the function so this file works properly in tests
    const {
      serverRuntimeConfig: {
        API_URL_BENTO_SERVER,
        API_URL_SERVICES_SERVER,
      },
      publicRuntimeConfig: {
        API_URL_BENTO_PUBLIC,
        API_URL_SERVICES_PUBLIC,
      },
    } = getConfig();


    const state = getState();
    const [PENDING, SUCCESS, ERROR] = types;

    const pending = createAction(PENDING);
    const success = createAction(SUCCESS);
    const error = createAction(ERROR);

    dispatch(pending(endpoint));

    try {
      // use server side urls if defined, otherwise use the public urls
      const API_URL_BENTO = API_URL_BENTO_SERVER || API_URL_BENTO_PUBLIC;
      const API_URL_SERVICES = API_URL_SERVICES_SERVER || API_URL_SERVICES_PUBLIC;

      let baseUrl = API_URL_BENTO;
      if (!!api && api === 'services') {
        baseUrl = API_URL_SERVICES;
      }

      // Use client path if resource is requested from client side
      const parsedUrl = parseOnClient(baseUrl);
      if (parsedUrl.pathname) {
        const {
          hostname, pathname, port, protocol,
        } = parsedUrl;
        baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}${pathname}`;
      }

      const queryParams = [];

      // Handle BENTO API variable override in query string parameter
      if (!api && state.shared && state.shared.bento) {
        queryParams.push(`bento=${state.shared.bento}`);

        if (state.shared.curator) {
          queryParams.push(`curator=${state.shared.curator}`);
        }
      }

      const endpointContainsQueryString = endpoint.includes('?');
      const query = queryParams.length
        ? `${endpointContainsQueryString ? '&' : '?'}${queryParams.join('&')}`
        : '';

      const response = await fetch(`${baseUrl}/${endpoint}${query}`);

      if (response.status >= 400) { // catch 4xx & 5xx errors
        const message = `${response.statusText} (${response.status}) @ ${response.url}`;

        return dispatch(error({ message, status: response.status, url: response.url }));
      }

      const json = await response.json();
      return dispatch(success({ ...json, additionalData, cacheKey }));
    } catch (e) {
      return dispatch(error(e.message));
    }
  };
}
